import { useViewScroll } from '@/layout/View/View.hooks'

import View from './View'

export { useViewScroll }

export default View
